import { useSelector } from "react-redux";
import { PAGE_TYPES } from "../../constants/tracking";

const getAdExclusions = (adExclusions) =>
    adExclusions === null ? [] : adExclusions;

export const useAdProps = () => {
    const stateAdExclusion = useSelector(
        (state) => state.detail.content.adExclusions
    );
    const { pageType, contentId: stateContentId } = useSelector(
        (state) => state.app
    );

    // sometimes we get back null for adExclusions
    // there is no adExclusions in the media json
    const adExclusions =
        pageType === PAGE_TYPES.DETAIL
            ? getAdExclusions(stateAdExclusion)
            : null;
    // we only need adExclusions on detail pages
    const contentId =
        pageType === PAGE_TYPES.DETAIL ? stateContentId : pageType;

    return {
        adExclusions,
        contentId,
    };
};
